<template>
    <div id="show-res-dialog" class="show-res-dialog dialog" style="display: none">
        <div class="dialog__container" style="background-color: white">

            <div class="dialog__container--title">
                查看訂單
            </div>

            <div v-if="reservations.length" class="res-dialog-list popsale-list">
                <div v-for="res in reservations" class="popsale-list--item mdc-elevation--z2" style="padding: 0 15px">
                    <div class="popsale-list--item__title">[{{res.id}}]{{ res.name }}</div>
                    <div class="popsale-list-item__content">由{{ res.start_at }}到{{res.end_at}} 「枱號：{{ res.table_number }}」「人數：{{res.person}}位」</div>

                    <div class="popsale-list-item__actions">
                        <button class="popsale-button delete"  data-mdc-auto-init="MDCRipple" v-on:click.prevent="destroy($event, res)">
                            <span>刪除</span>
                        </button>
                    </div>
                </div>
            </div>


            <div v-else-if="!this.loading && this.reservations.length <=0" class="dialog__none">
                <span class="res-dialog-list__none">你還沒有任何預訂</span>
            </div>

            <div v-else>
                <span class="res-dialog-list__none">讀取中 ... </span>
            </div>


            <div class="dialog__container--action">
                <button id="show-res-dialog-close" type="button" class="mdc-button mdc-button--raised" v-on:click.prevent="hide">
                    <span class="mdc-button__label">
                        取消
                    </span>
                </button>
                <button id="show-res-dialog-reload" type="button" class="mdc-button mdc-button--raised" v-on:click.prevent="reload">
                    <span class="mdc-button__label">
                        重整
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                required: true,
            }
        },
        data: function () {
            return {
                reservations: [],
                loading: false,
                url: `/system/store/${this.id}/reservations`
            }
        },
        methods: {
            reload: function () {
                this.reservations = [];
                this.loading = true;

                popsale.formRequest(this.url, 'get',null,function (response) {

                    this.reservations = response;
                    this.loading = false;

                }.bind(this));
            },
            hide: function () {
                $('#show-res-dialog').hide();
            },
            show: function () {
                $('#show-res-dialog').show();
            },
            edit: function (event, reserve) {
                event.preventDefault();
                window.location = `/system/store/${this.id}/table/${reserve.table_id}/reserve/${reserve.id}`;
            },
            destroy: function (event, reserve) {
                event.preventDefault();
                let url = `/system/store/${this.id}/table/${reserve.table_id}/reserve/${reserve.id}`;
                this.loading = true;
                popsale.formRequest(url, 'delete', null, function () {
                    this.loading = false;
                    this.reload();
                    popsale.snackText('已刪除');
                }.bind(this));
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.reload();
                let ripples = $('.popsale-button').map(function (index, object) {
                    return new window.mdc.ripple.MDCRipple(object);
                });
            }.bind(this));
        }
    }
</script>

<style lang="scss">
    .res-dialog-list {
        max-height: 50vh;
        overflow: auto;
    }

    .res-dialog-list__title {
        padding: 10px;
        font-weight: 600;
        font-size: 1.5em;
        color: #bc9c9e;
    }

    .res-dialog-list__none {
        display: block;
        padding: 28px;
        font-weight: 600;
        font-size: 1.5em;
        color: #bc9c9e;
        text-align: center;
    }
</style>